import React, { Component, PropTypes } from 'react';
import VideoRemoteControlButton from 'components/videoRemoteControlButton';

export default class FunVideoRemote extends Component {

  static contextTypes = {
    program: PropTypes.object.isRequired,
    session: PropTypes.object.isRequired,
    setMode: PropTypes.func.isRequired,
    setVideoState: PropTypes.func.isRequired,
    regionData: PropTypes.object.isRequired,
    i18n: PropTypes.func.isRequired
  };

  close (evt) {
    const { setMode, setVideoState } = this.context;
    setMode('extras').then(() => {
      setVideoState({
        playing: false,
        started: false,
        finished: false
      });
    });
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  render () {
    const { program: { funMd }, session: { mode }, regionData, i18n: _ } = this.context;
    let videoNumber = null;
    const match = mode ? mode.match(/^extras\/(.*)$/) : null;
    if (match) {
      videoNumber = Number(match[1]);
    } else {
      return <div />;
    }
    const funMd_i18n = _(funMd);
    const funItemNames = funMd_i18n.getSectionNames();
    const funItemName = funItemNames[videoNumber - 1];
    const description = funMd_i18n.getSubSectionAsString(
      funItemName,
      'Description',
      false,
      regionData
    );

    return (
      <div className="fun-video-remote">

        <button
            className="btn btn-sm go-back"
            onClick={::this.close}>
          {_('Go Back')}
        </button>

        <h4 className="fun-title">
          {funItemName}
        </h4>

        <div className="video-button-container">
          <VideoRemoteControlButton />
        </div>

        <div className="fun-description">
          <p>
            {description}
          </p>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/hudTeacherRemote/fun/funVideoRemote.jsx